import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import { App } from './app';
import reportWebVitals from './reportWebVitals';
import { rootElement } from 'app/constants';
import { AuthProvider } from 'auth/contexts/Auth';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById(rootElement.id)
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
